import React from 'react';
import { Check, X } from 'lucide-react';
export function EaseSection() {
  const noNecesitas = ['Pesar tu comida obsesivamente', 'Contar calorías o macros', 'Comprar ingredientes raros o caros', 'Pasar horas cocinando cada día', 'Dejar de comer carbohidratos'];
  const obtienes = ['Plan estructurado día por día', 'Recetas simples de 15-20 minutos', 'Ingredientes de tu supermercado local', 'Resultados visibles desde la semana 1', 'Libertad para disfrutar comidas sociales'];
  return <section className="py-10 bg-white" data-id="element-123">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="max-w-5xl mx-auto" data-id="element-125">
          <div className="text-center mb-8" data-id="element-126">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-sage mb-4" data-id="element-127">
              Diseñado para la vida real
            </h2>
            <p className="text-lg text-sage/80 max-w-2xl mx-auto" data-id="element-128">
              Sabemos que estás ocupada. Por eso eliminamos la fricción. Si es
              complicado, no es sostenible.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-129">
            {/* Lo que NO necesitás */}
            <div className="bg-cream rounded-3xl p-8 md:p-10 border border-red-100 shadow-sm" data-id="element-130">
              <h3 className="text-2xl font-serif font-bold text-sage mb-8 text-center" data-id="element-131">
                Lo que NO necesitás
              </h3>
              <ul className="space-y-6" data-id="element-132">
                {noNecesitas.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-133">
                    <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-134">
                      <X className="w-5 h-5 text-red-600" data-id="element-135" />
                    </div>
                    <span className="text-sage/80 font-medium" data-id="element-136">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Lo que obtenés */}
            <div className="bg-sage text-cream rounded-3xl p-8 md:p-10 shadow-xl relative overflow-hidden" data-id="element-137">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-138"></div>

              <h3 className="text-2xl font-serif font-bold text-white mb-8 text-center relative z-10" data-id="element-139">
                Lo que obtenés
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-140">
                {obtienes.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-141">
                    <div className="bg-gold p-2 rounded-full flex-shrink-0" data-id="element-142">
                      <Check className="w-5 h-5 text-white" data-id="element-143" />
                    </div>
                    <span className="text-cream font-medium" data-id="element-144">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center bg-cream rounded-2xl p-8 border border-gold/30 max-w-3xl mx-auto" data-id="element-145">
            <p className="text-xl md:text-2xl font-serif font-bold text-sage" data-id="element-146">
              Empezá hoy con 2 ingredientes de tu cocina:{' '}
              <span className="text-gold" data-id="element-147">Jengibre y Manzanilla</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}